(function () {
  const promoInjector = document.querySelector('[data-promo-injector]');
  if (!promoInjector) return;

  const promoData = {
    desktopPosition: parseInt(promoInjector.querySelector('[data-promo-desktop-position]')?.textContent || '3'),
    mobilePosition: parseInt(promoInjector.querySelector('[data-promo-mobile-position]')?.textContent || '2'),
    desktopImage: promoInjector.querySelector('[data-promo-desktop-image]')?.textContent || '',
    mobileImage: promoInjector.querySelector('[data-promo-mobile-image]')?.textContent || '',
    title: promoInjector.querySelector('[data-promo-title]')?.textContent || '',
    buttonText: promoInjector.querySelector('[data-promo-button-text]')?.textContent || '',
    link: promoInjector.querySelector('[data-promo-link]')?.textContent || '',
  };

  if (!promoData.title && !promoData.desktopImage && !promoData.mobileImage) return;

  const createPromoElement = (isMobile = false) => {
    const promoElement = document.createElement('div');
    promoElement.className = `collection-promo-injected ${isMobile ? 'mobile-only' : 'desktop-only'}`;
    const imageUrl = isMobile ? promoData.mobileImage : promoData.desktopImage;

    if (imageUrl) {
      promoElement.style.backgroundImage = `url('${imageUrl}')`;
    }

    promoElement.innerHTML = `
      <div class="promo-content">
        <div class="promo-text-content">
          ${promoData.title ? `<h3>${promoData.title}</h3>` : ''}
          ${promoData.buttonText && promoData.link ? `<a href="${promoData.link}" class="button">${promoData.buttonText}</a>` : ''}
        </div>
      </div>
    `;

    return promoElement;
  };

  const injectPromo = (promoElement, position, isMobile = false) => {
    const productGrid = document.querySelector('#ProductGridContainer');

    if (!productGrid) {
      setTimeout(() => injectPromo(promoElement, position, isMobile), 100);
      return;
    }

    const products = productGrid.querySelectorAll('li[class*="product"].grid__item');

    if (products.length === 0) {
      setTimeout(() => injectPromo(promoElement, position, isMobile), 100);
      return;
    }

    const insertPosition = Math.min(position, products.length);
    const wrapper = document.createElement(products[0].tagName);
    wrapper.className = products[0].className;
    wrapper.appendChild(promoElement);

    if (insertPosition < products.length) {
      products[insertPosition - 1].after(wrapper);
    } else {
      productGrid.appendChild(wrapper);
    }
  };

  if (promoData.desktopImage || promoData.title) {
    injectPromo(createPromoElement(false), promoData.desktopPosition, false);
  }

  if (promoData.mobileImage || promoData.title) {
    injectPromo(createPromoElement(true), promoData.mobilePosition, true);
  }
})();
